import { FilterId } from "../../../../../../shared";

export const isUserAndRootSameCompany = (
    userCompanyId: number | undefined,
    rootCompanyId: FilterId | undefined
) => userCompanyId === Number(rootCompanyId);
